<template>
  <div class="im-right-list">
    <div class="conversation-list-wrapper">
      <slot name="sidebar-operation"></slot>
      <slot name="sidebar-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImRightListLayout',
}
</script>

<style lang="stylus" scoped>
.im-right-list {
  width: 260px;
  border-right: 1px solid #ded9d9;
  background-color: #f7f7f7;
}
.conversation-list-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  //overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ImRightListLayout.vue